<div class="banner-slides">
  @for (slide of bannerSlidesInput(); track $index) {
    <div
      class="banner-slides__banner"
      [class]="{ 'banner-slides__banner--active': $index === currentSlide(), 'banner-slides__banner--gradient': !slide.Video && hasGradient() }"
      [style]="{'cursor': slide.UrlFixa ? 'pointer' : ''}"
      (click)="$index === currentSlide() ? openLink(slide.UrlFixa) : null"
      >
      @if (slide.Imagem || slide.ImagemModal) {
        <img 
          [src]="isModal() 
          ? slide.ImagemModal 
          : slide.Imagem" 
          [alt]="slide.Titulo" />
      }

      @if (slide.SafeVideo) {
        <iframe class="modal-anuncio__iframe" width="100%" height="100%" [src]="slide.SafeVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      }

      <div class="banner-slides__content">
        @if (slide.Titulo) {
          <h1 class="banner-slides__title">
            {{ slide.Titulo }}
          </h1>
        }

        @if (slide.Mensagem) {
          <p class="banner-slides__message">
            {{ slide.Mensagem }}
          </p>
        }
      </div>
    </div>
  } @empty {
    @if (!bannerSlidesInput().length && !isLoading()) {
      <div
        class="banner-slides__banner banner-slides__banner--gradient"
        [class]="{ 'banner-slides__banner--active': !bannerSlidesInput().length }">
        <img src="assets/images/brand/banner-gestor.png" alt="Banner Gestor" />
      </div>
    } @else {
      <!-- <app-spinner [diameter]="40" [strokeWidth]="4"></app-spinner> -->
    }
  }

  @if (bannerSlidesInput().length > 1) {
    <div class="banner-slides__navigation">
      <button (click)="prevSlide()" aria-label="Voltar para o slide anterior">
        <ng-icon name="heroArrowLeftCircle" strokeWidth="0.8"></ng-icon>
      </button>

      <ul class="banner-slides__pages">
        @for (slide of bannerSlidesInput(); track $index) {
          <li
            class="banner-slides__page"
            [class]="{
              'banner-slides__page--active': currentSlide() === $index,
            }"
            role="button"
            tabindex="0"
            (click)="goToSlide($index)"
            (keydown)="goToSlide($index)"
            (keyup)="goToSlide($index)"></li>
        }
      </ul>

      <button (click)="nextSlide()" aria-label="Avançar para o próximo slide">
        <ng-icon name="heroArrowRightCircle" strokeWidth="0.8"></ng-icon>
      </button>
    </div>
  }
</div>
